import { render, staticRenderFns } from "./ActionForValue.vue?vue&type=template&id=188efb6f"
import script from "./ActionForValue.vue?vue&type=script&lang=js"
export * from "./ActionForValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports